import { Component, QueryList, Input, OnInit, Host, ViewChild, ContentChildren, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { PageComponent } from './pageComponent.component';

@Component({
    selector: 'carousel',
    template: `
    <div style="opacity:.99">    
        <ng-content></ng-content>
    </div>
  `
})


export class Carousel implements AfterViewInit {
    pageNumber: number = 0;
    @ContentChildren(PageComponent) _pages!: QueryList<PageComponent>;

    ngAfterViewInit(): void {
        this.selectPage(0);
        //this.ref.detectChanges();
    }

    previous(): void {
        if (0 < this.pageNumber) {
            this.selectPage(this.pageNumber - 1);
        }
    }

    next(): void {
        if (this.pageNumber < 2) {
            this.selectPage(this.pageNumber + 1);
        }
    }

    selectPage(pageNum: number) {
        let pages: PageComponent[] = this._pages.toArray();
        pages.forEach((page, i) => {
            if (i != pageNum) {
                page.flyPosition = (i < pageNum) ? 'left' : 'right';
                //page.selected= false;
            }
        });
        //pages[pageNum].selected = true;
        //pages[pageNum].flyPosition = "selected";
        pages[pageNum].select();
        this.pageNumber = pageNum;
    }
}